import { render } from "./taste-notes.vue?vue&type=template&id=d244b500"
import script from "./taste-notes.vue?vue&type=script&lang=js"
export * from "./taste-notes.vue?vue&type=script&lang=js"

import "./taste-notes.vue?vue&type=style&index=0&id=d244b500&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__